/**
 * THE FOUR MARKS ON THE ROOM'S CONTROLS.
 *
 * Their own file because two screens draw them now — the board and the farm auction (Tim, 8
 * September: "need start/pause, reset pick, reset draft, undo/redo controls on the farm rounds
 * just like the main draft"). "Just like" is the requirement, and the surest way to keep two
 * control bars looking alike is for there to be one set of marks rather than two that drifted.
 */

/**
 * PAUSE AND PLAY, DRAWN (Tim, 6 September: "draft pause should use pause icon instead of stop").
 * `❚❚` is two heavy vertical bars in a face that has them and a single filled block in one that
 * does not — and the display face here does not, so the running switch wore a stop button. Two
 * rectangles and a triangle, sized to the label, settle it in every face.
 */
export function PauseMark() {
  return (
    <svg viewBox="0 0 12 12" width="10" height="10" aria-hidden="true" focusable="false"
      fill="currentColor">
      <rect x="2" y="1.5" width="3" height="9" rx="1" />
      <rect x="7" y="1.5" width="3" height="9" rx="1" />
    </svg>
  );
}

export function PlayMark() {
  return (
    <svg viewBox="0 0 12 12" width="10" height="10" aria-hidden="true" focusable="false"
      fill="currentColor">
      <path d="M3 1.7 10.4 6 3 10.3Z" />
    </svg>
  );
}

/**
 * THE UNDO ARROW, DRAWN (Tim, 6 September: "add an icon to undo").
 *
 * `↶` and `↷` go the way of `↻` and `❚❚` before them — the display face does not carry them, so
 * both buttons fell back to nothing and read as bare words on a row where everything else has a
 * mark. One curve with an arrowhead, mirrored for redo, sized to the label beside it.
 */
export function UndoMark({ forward = false }: { forward?: boolean }) {
  return (
    <svg className={`ccrot ccundoic${forward ? ' fwd' : ''}`} viewBox="0 0 16 16"
      width="13" height="13" aria-hidden="true" focusable="false" fill="none"
      stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round">
      {/* The turn: left along the top, round, and back under it. */}
      <path d="M2.4 6.4h6.9a3.9 3.9 0 0 1 0 7.8H6.3" />
      {/* And the head it turns away from. */}
      <path d="M5.6 3.2 2.4 6.4l3.2 3.2" />
    </svg>
  );
}

export function RestartIcon() {
  return (
    <svg className="ccrot" viewBox="0 0 16 16" width="12" height="12" aria-hidden="true"
      focusable="false" fill="none" stroke="currentColor" strokeWidth="1.9"
      strokeLinecap="round" strokeLinejoin="round">
      <path d="M13.4 6.4A5.6 5.6 0 1 0 13.9 9.6" />
      <path d="M13.7 2.4v4.1h-4.1" />
    </svg>
  );
}
